import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cfba46c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.4317 0H86.4279L91.8711 82.7338C92.1096 86.3411 90.4363 89.8062 87.4627 91.8675L50.249 117.657L14.0086 90.1754C11.2851 88.1102 9.76173 84.8259 9.95022 81.4147L14.4317 0Z\" fill=\"#D50004\" data-v-2cfba46c></path><path d=\"M14.4317 0H86.4279L91.8711 82.7338C92.1096 86.3411 90.4363 89.8062 87.4627 91.8675L50.249 117.657L14.0086 90.1754C11.2851 88.1102 9.76173 84.8259 9.95022 81.4147L14.4317 0Z\" stroke=\"transparent\" data-v-2cfba46c></path><path d=\"M58.9278 30.9882L58.1789 25.8543C58.1245 25.4829 57.9257 25.1475 57.6262 24.9257L39.1591 11.3203C38.7697 11.0348 38.2333 11.3674 38.3096 11.8525L40.6295 26.7303C40.6867 27.099 40.8882 27.4261 41.185 27.6423L56.9128 39.0162C58.8733 40.4328 58.5193 41.7883 56.1258 42.0267L56.0305 42.035C53.2341 42.3649 53.0734 43.3046 55.2354 45.04L67.3036 53.7194C67.6984 54.0021 68.2348 53.6639 68.1586 53.1788L65.5064 36.136C65.4492 35.7618 65.2423 35.4264 64.9346 35.2101L58.9441 31.0077C58.9441 31.0077 58.9332 30.9966 58.9332 30.9882H58.9278Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M42.5409 60.8004C42.0166 60.8394 42.5409 60.8004 42.5409 60.8004C42.1833 60.8561 41.4922 60.4581 41.4116 59.9126L34.5039 10.8264C34.4233 10.2809 34.6975 10.0082 35.0551 9.95249C35.4128 9.89683 35.7193 10.0777 35.7999 10.6232L43.3637 59.6426C43.4874 60.3635 43.0625 60.7615 42.5382 60.8004H42.5409Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M31.8223 77.2317L29.6103 69.1342C29.4728 68.6288 29.1604 68.3762 28.6855 68.3762C28.2731 68.3762 27.9482 68.6048 27.7607 69.0018L25.0613 74.5606L22.3619 69.0018C22.162 68.6048 21.7871 68.3762 21.3872 68.3762C20.8873 68.3762 20.5749 68.6288 20.4374 69.1342L18.2129 77.2317H20.125L21.5996 71.709L24.0116 76.6542C24.224 77.0994 24.5364 77.352 24.9988 77.352C25.4737 77.352 25.7612 77.0994 25.9861 76.6542L28.4106 71.709L29.8977 77.2317H31.8223Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M34.1595 77.2317V68.4845H32.21V77.2317H34.1595Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M41.9344 77.2317C43.909 77.2317 44.8713 76.1127 44.8713 74.6087C44.8713 72.8641 43.8465 72.0459 41.9344 72.0459H37.8479C37.3105 72.0459 36.9606 71.7451 36.9606 71.2037C36.9606 70.6622 37.298 70.3614 37.8479 70.3614H44.4214V68.4845H37.8479C35.9608 68.4845 34.936 69.5673 34.936 71.0112C34.936 72.4911 36.0358 73.5259 37.8229 73.5259H41.9344C42.6343 73.5259 43.0342 73.8628 43.0342 74.4523C43.0342 75.0058 42.6343 75.3547 41.9344 75.3547H35.0735V77.2317H41.9344Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M50.2302 77.2317V70.3614H53.5669V68.4845H44.9439V70.3614H48.2806V77.2317H50.2302Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M64.7357 77.2317L62.0113 74.5967C63.1485 74.1636 63.8484 73.1649 63.8484 71.7331C63.8484 69.7478 62.5862 68.4845 60.4616 68.4845H53.8631V77.2317H55.8002V70.3614H60.4616C61.3864 70.3614 61.9363 70.8548 61.9363 71.7812C61.9363 72.7077 61.4114 73.2491 60.4616 73.2491H56.9374V74.8494H59.7618L61.9738 77.2317H64.7357Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M76.3928 77.2317L71.2315 68.9657C71.0065 68.6048 70.7191 68.3641 70.2942 68.3641C69.8693 68.3641 69.5818 68.6048 69.3569 68.9657L64.1956 77.2317H66.4076L70.2192 71.0112L71.8813 73.7063H69.8318L68.9445 75.1622H72.7811L74.0558 77.2317H76.3928Z\" fill=\"white\" data-v-2cfba46c></path><path d=\"M84.4424 77.2317V75.3547H78.5687V68.4845H76.6192V77.2317H84.4424Z\" fill=\"white\" data-v-2cfba46c></path>", 11)
const _hoisted_13 = [
  _hoisted_2
]

import useBreakpoints from '@/composables/useBreakpoints';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isDesktop } = useBreakpoints();
// import { computed } from 'vue';

// import useDarkMode from '@/composables/useDarkMode';
// import useTailwind from '@/composables/useTailwind';

/**
 * TYPES
 */
// type Props = {
//   forceDark?: boolean;
// };

/**
 * PROPS & EMITS
 */
// const props = withDefaults(defineProps<Props>(), {
//   forceDark: false,
// });

/**
 * COMPOSABLES
 */
// const { darkMode } = useDarkMode();
// const tailwind = useTailwind();

/**
 * COMPUTED
 */
// const fillColor = computed(() => {
//   if (props.forceDark) return tailwind.theme.colors.white;

//   return darkMode.value
//     ? tailwind.theme.colors.white
//     : tailwind.theme.colors.gray['900'];
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(isDesktop) ? 'app-logo-desktop' : 'app-logo-mobile')
  }, [
    (_openBlock(), _createElementBlock("svg", {
      width: _unref(isDesktop) ? '101' : '101',
      height: _unref(isDesktop) ? '145' : '120',
      viewBox: _unref(isDesktop) ? '0 0 101 145' : '0 0 101 120',
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_13, 8, _hoisted_1))
  ], 2))
}
}

})